<template>
  <v-container fluid>
    <v-layout class="identity">
      <v-flex xs12>
        <h1 class="primary--text">MC Consultant</h1>
        <span class="secondary--text" v-t="'Home.Main.Name'" /> 
      </v-flex>
      <v-flex xs6 class="flex-center hidden-sm-and-down">
        <!-- <contact-icons /> -->
        <button class="section-btn" @click="scrollToContact()">Contactez-nous</button>
      </v-flex>
    </v-layout>
    <div class="home-picture">
      <div class="dark-overlay">
        <h2>Conseil</h2>
        <h2>Développement</h2>
        <h2>Accompagnement</h2>
        <h2>Défense</h2>
      </div>
    </div>
    <services-section />
    <linkedin-section />
    <valeurs-section />
    <contact-section />
  </v-container>
</template>

<script>
import ServicesSection from '@/components/sections/ServicesSection.vue'
import ValeursSection from '@/components/sections/ValeursSection.vue'
import LinkedinSection from '@/components/sections/LinkedinSection.vue'
import ContactSection from '@/components/sections/ContactSection.vue'

export default {
  name: 'Home',
  components: {
    ServicesSection,
    ValeursSection,
    LinkedinSection,
    ContactSection
  },
  methods: {
    scrollToContact () {
      window.scrollTo(0, document.body.scrollHeight)
    }
  }
}
</script>

<style>
.identity {
  margin-top: 40px;
  margin-bottom: 60px;
  padding-left: 85px;
}
.identity span {
  font-family: 'Montserrat';
  font-size: 1.8rem;
  font-weight: 400;
}

.smOnly .identity {
  padding: 0 32px;
  margin-top: 10px;
  margin-bottom: 24px;
}
  
.xsOnly .identity {
  padding: 0 32px;
  margin-top: 0;
  margin-bottom: 24px;
}
.xsOnly .identity .flex,
.smOnly .identity .flex {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: wrap;
}
.smOnly .identity h1,
.smOnly .identity span,
.xsOnly .identity h1,
.xsOnly .identity span {
  text-align: center;
  margin: auto;
}
.smOnly .identity h1 {
  font-size: 2.3rem;
}
.xsOnly .identity h1 {
  font-size: 1.6rem;
}
.smOnly .identity span {
  font-size: 1.5rem;
}
.xsOnly .identity span {
  font-size: 1rem;
}

.home-picture {
  width: 100%;
  height: 400px;
  /* background: url('../assets/homepage1.png') no-repeat center center; */
  background: url('../../public/homepage1.png') no-repeat center center;
  background-size: cover;
}
.dark-overlay {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  top: 0;
  left: 120px;
  width: 30%;
  height: 400px;
  background-color: rgba(50, 50, 50, 0.5);
}
.dark-overlay h2 {
  margin: auto;
  color: #FFF;
  padding: 0 !important;
  text-transform: uppercase;
  font-size: 2.1vw;
}
.smOnly .home-picture {
  height: 280px;
}
.smOnly .dark-overlay {
  height: 280px;
  left: 80px;
}
.smOnly .dark-overlay h2 {
  font-size: 14px;
}
.xsOnly .home-picture {
  height: 180px;
}
.xsOnly .dark-overlay {
  height: 180px;
  left: 30px;
  width: 35%;
}
.xsOnly .dark-overlay h2 {
  font-size: 10px;
}
</style>

